import { TypedDocumentNode, gql } from '@apollo/client';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Card } from '@sorare/core/src/components/card/Card';

import { BuyCommonCard } from 'components/commonCard/BuyCommonCard';

import { AnyPlayerProperties } from './AnyPlayerProperties';
import type { CommonPlayerPreview_commonPlayer } from './__generated__/index.graphql';

type Props = {
  commonPlayer: CommonPlayerPreview_commonPlayer;
  onStatsClick: () => void;
  showPlayerCostHighlight?: boolean;
};

export const CommonPlayerPreview = ({
  commonPlayer,
  onStatsClick,
  showPlayerCostHighlight,
}: Props) => {
  const { anyPlayer } = commonPlayer;
  return (
    <Vertical>
      <Card card={commonPlayer} onClick={onStatsClick} />
      <AnyPlayerProperties player={anyPlayer} onStatsClick={onStatsClick} />

      <BuyCommonCard
        commonPlayer={commonPlayer}
        showPlayerCostHighlight={showPlayerCostHighlight}
      />
    </Vertical>
  );
};

CommonPlayerPreview.fragments = {
  commonPlayer: gql`
    fragment CommonPlayerPreview_commonPlayer on CommonPlayer {
      id
      anyPlayer {
        slug
        ...AnyPlayerProperties_anyPlayer
      }
      ...Card_commonPlayer
      ...BuyCommonCard_commonPlayer
    }
    ${AnyPlayerProperties.fragments.anyPlayer}
    ${Card.fragments.commonPlayer}
    ${BuyCommonCard.fragments.commonPlayer}
  ` as TypedDocumentNode<CommonPlayerPreview_commonPlayer>,
};
